/* @flow */

import * as React from 'react';
import PropTypes from 'prop-types';

type Props = {
  children: React$Element<*>,
  period?: number,
};

type Listener = (timestamp: number) => void;

class TimerProvider extends React.Component<Props> {
  props: Props;
  subscriptions: Set<Listener> = new Set(); // eslint-disable-line react/sort-comp
  timerId: number = 0;

  static defaultProps = {
    period: 1000,
  };

  static childContextTypes = {
    timer: PropTypes.shape({
      subscribe: PropTypes.func.isRequired,
      unsubscribe: PropTypes.func.isRequired,
    }).isRequired,
  };

  getChildContext() {
    return {
      timer: {
        subscribe: this.subscribe,
        unsubscribe: this.unsubscribe,
      },
    };
  }

  componentDidMount() {
    this.tick();
  }

  componentDidUpdate(prevProps: Props) {
    if (this.props.period !== prevProps.period) {
      this.kill();
      this.tick();
    }
  }

  componentWillUnmount() {
    this.kill();
  }

  tick = () => {
    const { period } = this.props;
    this.timerId = setInterval(this.triggerAll, period);
  }

  kill = () => {
    clearInterval(this.timerId);
  }

  triggerAll = () => {
    const timestamp = Date.now();
    this.subscriptions.forEach(listener => listener(timestamp));
  };

  subscribe = (listener: Listener) => {
    this.subscriptions.add(listener);
  }

  unsubscribe = (listener: Listener) => {
    this.subscriptions.delete(listener);
  }

  render() {
    return this.props.children;
  }
}

export default TimerProvider;
